<template>
<div>
  <page-header :title="title"></page-header>
  <form @submit.prevent="gravar">
    <div class="modal-body">
      <div class="form-horizontal">
        <vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>
        <input-form-text textInput="Título" :required="true" v-model="form.titulo" :value="form.titulo"></input-form-text>

        <div class="form-group">
          <label class="col-sm-3 control-label no-padding-right">Grupo</label>
          <div class="col-sm-5">
            <select class="form-control" v-model="form.grupo" required>
              <option value="2026">PNAB LEI ALDIR BLANC 2026 - CICLO II</option>
              <option value="2020">LEI ALDIR BLANC Nº 14017/2020</option>
            </select>
          </div>
        </div>

        <input-form-text textInput="Ordem" v-model="form.ordem" :value="form.ordem"></input-form-text>

		<div class="form-group">
			<label class="col-sm-3 control-label no-padding-right">Selecione</label>
			<div class="col-sm-5">
				<div class="radio">
					<label>
						<input name="form-field-radio" type="radio" class="ace" value="1" v-model="select">
						<span class="lbl"> Arquivo</span>
					</label>
				</div>
				<div class="radio">
					<label>
						<input name="form-field-radio" type="radio" class="ace" value="2" v-model="select">
						<span class="lbl"> Link</span>
					</label>
				</div>
			</div>
		</div>
		<div v-if="select == 2">
			<input-form-text textInput="URL" v-model="form.arquivo" :value="form.arquivo"></input-form-text>
		</div>
		<div class="form-group" v-else>
			<label class="col-sm-3 control-label no-padding-right"></label>
			<div class="col-sm-5">
				<file-upload v-if="!allFiles.length" ref="fupload" :url="'/v1/lei-aldir-blanc/upload'" :id="null"
					:label="'PDF ou DOCX até 10 MB'" :multiple="false" texto="Enviar Arquivos" accept=".pdf,.doc,.docx"
					:isFile="true"></file-upload>
				<items-edit v-else :files="allFiles" url="/v1/lei-aldir-blanc/upload" id="id"
					:isFile="true"></items-edit>
			</div>
		</div>
        <div class="form-group">
          <select-form v-model="form.ativo" :value="form.ativo" name="Ativo" url="/arquivos" id="id" titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
        </div>
      </div>
    </div>
    <footer-button :disabled="isActiveBtn"></footer-button>
  </form>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		fileUpload,
		ItemsEdit
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Lei Aldir Blanc',
			form: {
				titulo: '',
				grupo: '2026',
				ordem: '',
				arquivo: '',
				ativo: '1'
			},
			allFiles: [],
			isActiveBtn: false,
			isActive: false,
			select: '1'
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		buildSaveBody() {
			const body = { ...this.form }
			if (String(this.select) === '1') {
				delete body.arquivo
			}
			if (!body.ordem && body.ordem !== 0) {
				delete body.ordem
			}
			return body
		},
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.buildSaveBody()
			if (this.$route.params.id) {
				const resp = await req(`/v1/lei-aldir-blanc/${this.$route.params.id}`, 'put', body).catch(() => {
					erro()
				})
				if(this.$refs.fupload) {
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/links/lei-aldir-blanc')
			} else {
				const resp = await req('/v1/lei-aldir-blanc', 'post', body).catch(() => {
					erro()
				})
				if(this.$refs.fupload) {
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/links/lei-aldir-blanc')
			}
			this.isActive = false
			this.isActiveBtn = false
		},
		async getDados() {
			const resp = await req(`/v1/lei-aldir-blanc/${this.$route.params.id}`).catch(() => {
				erro()
			})
			this.form.ativo = resp.ativo
			this.form.titulo = resp.titulo
			this.form.grupo = resp.grupo || '2020'
			this.form.ordem = resp.ordem != null ? String(resp.ordem) : ''
			const raw = resp.arquivo_armazenamento || resp.arquivo || ''
			if (raw && /^https?:\/\//i.test(raw) && !/\/lei_aldir_blanc\//.test(raw)) {
				this.select = '2'
				this.form.arquivo = raw
				this.allFiles = []
			} else if (raw) {
				this.select = '1'
				this.form.arquivo = ''
				this.allFiles = resp.arquivo ? [{ id: this.$route.params.id, files: resp.arquivo }] : []
			} else {
				this.select = '1'
				this.form.arquivo = ''
				this.allFiles = []
			}
			this.isActive = false
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
